export function getEnvVarOrCry<K extends keyof typeof ENV_CONSTANTS>(key: K): typeof ENV_CONSTANTS[K];
export function getEnvVarOrCry(key: string): unknown;
export function getEnvVarOrCry(key: string): unknown {
  const value = ENV_CONSTANTS[key as keyof typeof ENV_CONSTANTS];

  if(value === undefined || value === null) {
    throw new Error(`getEnvVarOrCry - Environment variable ${key} not defined`);
  }

  return value;
}
